<template>
  <div class="hello">
    <el-container>
      <!--<el-aside width="60%" style="background: #fff;" :style="'min-height:'+windowHeight+'px'">-->
      <el-aside width="60%" style="background: #fff;">
        <!--<el-form :inline="true"  label-suffix=":" size="small" label-width="160px">-->
        <div class="service_team">
          <p class="my_mission" style="margin: 0">我的服务团队</p>
          <div class="service_team_box">
            <el-row type="flex" style="flex-wrap:wrap;" :gutter="15">
              <el-col v-for="(item,index) in teamTeacherInfo" :key="index" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <div class="service_team_item">
                  <img :src="item.src" alt="teacher">
                  <div>
                    <p>{{item.text}}</p>
                    <p>{{item.name}}</p>
                    <button>联系我</button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="my_mission">我的任务</div>
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick" class="mta_tabs">
          <el-tab-pane  v-for="(blockOne,index) in blockArr" :key="index" :label="blockOne.blockName" :name="'first'+index" style="padding: 20px 10px">
            <el-row type="flex" style="flex-wrap:wrap;" :gutter="15">
              <el-col v-for="(kbOne,kbIndex) in blockOne.kbList" style="margin-bottom: 10px" :key="kbIndex" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="itemCard" @click="clickToList(kbOne)">
                  <img src="../../pages/home/img/itemImg.png" alt="img" class="itemImg">
                  <div class="itemText">
                    <span>{{kbOne.cnName}}</span>
                    <span><em :style="kbOne.value?'':'color:#BEB7B1'">{{kbOne.value?kbOne.value:0}}</em>个</span>
                  </div>
                  <el-button class="taskStatus1" type="text">{{taskStatus}}</el-button>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
          <!--<el-collapse v-model="activeNames" class="mta_tabs">-->
            <!--<el-collapse-item v-for="(blockOne,index) in blockArr" :key="index"-->
                              <!--:title="blockOne.blockName" :name="index"-->
            <!--&gt;-->
              <!--<el-row type="flex" style="flex-wrap:wrap;" >-->
                <!--<el-col v-for="(kbOne,kbIndex) in blockOne.kbList" :key="kbIndex"-->
                        <!--:xs="24" :sm="24" :md="12" :lg="8" :xl="8"-->
                <!--&gt;-->
                  <!--<el-form-item :label="kbOne.cnName" label-width="160px">-->
                    <!--<el-button type="primary" plain-->
                               <!--@click="clickToList(kbOne)"-->
                    <!--&gt;{{kbOne.value?kbOne.value:0}}</el-button>-->
                  <!--</el-form-item>-->
                <!--</el-col>-->
              <!--</el-row>-->
            <!--</el-collapse-item>-->
          <!--</el-collapse>-->
        <!--</el-form>-->
      </el-aside>
      <el-main>
        <Schedule :type="system"></Schedule>
        <!--<el-collapse v-model="reprotActiveName" accordion>-->
          <!--<el-collapse-item v-for="(reportOne,reportIndex) in reportArr" :key="reportIndex"-->
            <!--:title="(reportOne.reportType==1?'报表:':'列表:')+reportOne.reportName" :name="reportIndex"-->
          <!--&gt;-->
            <!--<Report v-if="reportOne.reportType == 1" :ref="'listPage_'+reportOne.reportId" -->
              <!--:pageInfo="reportOne" :initReportType=1 >-->
            <!--</Report>-->
          <!--</el-collapse-item>-->
        <!--</el-collapse>-->
      </el-main>
    </el-container>
    
  </div>
</template>

<script>
import utils from '@/js/utils/util.js';
export default {
    name: 'DataBoard',
    data(){
        return {
            //首页的看板信息
            blockArr:[],
            //首页报表信息
            reportArr:[],
            reprotActiveName:0,
            activeNames:[0],
          activeNames1:'a0',
          activeName2:'first0',
//            调用日历组件的类型
            system:1,
          taskStatus:'做任务',
          windowHeight:500,

//          我的团队
          teamTeacherInfo:[{name:'李明飞',text:'我的名导老师',src:require('../../pages/home/img/teacherImg.png')},{name:'李明飞',text:'我的名导老师',src:require('../../pages/home/img/teacherImg.png')},{name:'李明飞',text:'我的名导老师',src:require('../../pages/home/img/teacherImg.png')}],
        }
    },
    created(){
      this.windowHeight = window.innerHeight-150;
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      clickToList(kbOne){
        //拼接打开页面的字段结构
        var pageOne = {};
        pageOne.tableId = kbOne.tableId;
        pageOne.pageId = kbOne.pageId;
        pageOne.menuId = "kb_"+kbOne.homeSetId;
        pageOne.menuName = "看板:"+kbOne.cnName;
        pageOne.ctType = 3;
        pageOne.SourceDataId = kbOne.homeSetId
        console.log(pageOne);
        //调用主页面模板的检查选项卡是否已经打开的功能
        this.$emit("checkTabExists",pageOne);
      },
      /**
       * 刷新看板信息
       */
      onRreshData(){
        var that = this;
        var url = "/wxXcxSet_interfaceToHomeSet.do";
        this.loading = true;
        this.$axios.post(url,{
        }).then(res => {
            that.loading = false;
            console.log("res.data===========================",res.data);
            if (res.data) {
              that.blockArr = res.data.userBlockList;
              that.reportArr = res.data.userReportList;
              that.msgNum = res.data.msgNum;
              that.$emit("setMsgNum",that.msgNum);
            } else{
                //登陆失败
                this.$message({
                    showClose: true,
                    message: '没有获取到对应的看板信息请重试!',
                    type: 'error'
                });
            }
        }).catch(error => {
            console.log("=====" + error);
        })
      }
    },
    /**
     * 页面创建时 进行后台数据请求 获取首页看板等信息
     */
    beforeMount : function(){
      var loginInfo = sessionStorage.loginInfo;
      console.log("loginInfo========================",loginInfo);
      if(utils.isNotNull(loginInfo)) {
        loginInfo = JSON.parse(loginInfo);
        console.log("USERID========================",loginInfo.USERID);
        if(loginInfo.USERID>0) {
          this.onRreshData();
        }
      }
    },
    props: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hello{margin-top: 15px}
  .el-main{padding: 0}
  .el-collapse{border: none}
  .itemCard{background: #FFF9EF;height: 70px;border-radius: 5px;display: flex;justify-content: space-around;align-items: center}
  .itemImg{width: 46px;height: 46px}
  /*做任务*/
  .taskStatus1{color: #ffffff;padding: 6px 15px;border-radius: 20px}
  /*已完成*/
  .taskStatus2{background: #E4E4E4;color: #A6A6A6}
  .itemText{width: 50%}
  .itemText span{display: block}
  .itemText em{color: #A5802C;font-size: 18px;font-style: normal;padding-right: 5px}
  .my_mission{color: #212121;font-size: 22px;padding: 5px;}
  .service_team{border-bottom: 10px solid #F7F7F7;}
  .bg_white{background: #ffffff}
  .service_team_box{padding: 10px 20px}
  .service_team_item{display: flex;justify-content: flex-start;align-items: center;}
  .service_team_item img{height: 70px;width: 60px;margin-right: 15px}
  .service_team_item p{margin: 0 0 5px 0}
  .service_team_item p:first-child{font-size: 12px}
  .service_team_item button{background: #FE727B;border: none;color: #fff;border-radius: 10px;font-size: 12px;padding: 0 12px}
</style>
<style>
  .lmf-tabs .mta_tabs .el-tabs__item{height: 26px;line-height: 26px;padding: 0 20px !important;margin: 0 10px !important;}
  .mta_tabs>.el-tabs__header .el-tabs__nav{border: none !important;}
  .mta_tabs>.el-tabs__header .el-tabs__item{border: none !important;}
  .lmf-tabs .mta_tabs .el-tabs__item.is-active{padding: 0 20px !important;height: 26px;line-height: 26px;margin: 0 10px !important;}
  .hello .el-collapse-item__header{padding: 0 10px}
  .hello .el-form-item__label{width: 150px}
</style>
